export const check_time_diff_from_now_to_target = (target_ymd_his) => {
    let target_datetime = target_ymd_his.split(" ");
    let target_date = target_datetime[0].split("-");
    let target_time = target_datetime[1].split(":");

    for(let i = 0; i < target_date.length; i++){
        target_date[i] = parseInt(target_date[i]);
    }
    for(let i = 0; i < target_time.length; i++){
        target_time[i] = parseInt(target_time[i]);
    }


    let future_utc = new Date(Date.UTC(target_date[0], (target_date[1] - 1), target_date[2], (target_time[0] - 3), target_time[1], 0));
    let now_utc = new Date().getTime();

    let diff = future_utc - now_utc;

    return diff;
};